/**
 * List component for transactions, managing list content and implementing event handler
 *
 * Properties:
 *
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useState, useEffect } from "react";
import { FormatHelper, Biscuit } from "../../../../utils";
import ListItem from "../../../components/ListItem";
import Popup from "../../../components/Popup";
import t from "../../../helpers/t";
import { _, moment } from "../../../../../vendor";
import { salesBillingsActions, userActions, useSelector } from "inbooma-api";
import { S3Client } from "aws_js";
import * as FileSaver from "../../../../../vendor/FileSaver";
import AdminTransactionListItem from "./AdminTransactionListItem";

const AdminTransactionsList = (props) => {
  let language = Biscuit.get("user.lang").replace("-", "_");

  const _salesBillings = useSelector((state) => state.sales_billings_data.salesBillings);
  const _user = useSelector((state) => state.users_data.user);
  const [popup, setPopup] = useState({
    open: false,
    linkText: "",
    link: "",
  });

  useEffect(() => {
    console.log("sales billings: ", _salesBillings);
    if (_salesBillings.success === "") {
      return;
    }

    if (_salesBillings.success === true) {
      if (_salesBillings.data.length > 0) {
        // create accumulated invoice
        _readFile(_salesBillings.data[0]);
      } else {
        // no accumulated invoice available from server
        // ... to-do: show notification
      }
      //setSalesBillings([..._salesBillings.data]);
    } else {
      console.log("Failed fetching sales billing!");
    }
  }, [_salesBillings]);

  useEffect(() => {
    if (_user.success == "") return;

    if (_user.success === true) {
      let info =
        typeof _user.data.first_name !== "undefined" && _user.data.first_name !== null
          ? _user.data.first_name
          : "";
      info +=
        typeof _user.data.last_name !== "undefined" && _user.data.last_name !== null
          ? " " + _user.data.last_name
          : "";

      // show popup with user info and link to user profile
      setPopup({
        left: popup.left,
        top: popup.top,
        open: true,
        text: popup.text,
        link: "users/" + _user.data.id + "?path=/finances/transactions",
        linkText: info.length == 0 ? _user.data.id : info,
      });
    } else {
      console.log("Failed to fetch user");
    }
  }, [_user]);

  const _readFile = (sales_billing) => {
    const file_name = sales_billing.file;

    S3Client.getDocument(
      Number(Biscuit.get("user.client_id")),
      "SalesBilling",
      sales_billing.location_id,
      file_name,
    )
      .then((data) => {
        const blob = new Blob([data.Body], { type: data.ContentType });
        FileSaver.saveAs(blob, file_name.replace(/_/gi, " "));
      })
      .catch((err) => {
        alert(`Error downloading file: ${err}`);
      });
  };

  const getPaymentTypeLabel = (pType, pStatus) => {
    let label = "";

    if (pType != null && pType != "") {
      if (pType == "credit") label = t("credit_card");
      if (pType == "sepa_debit") label = t("sepa") + " (online)";
      if (pType == "cash") label = t("cash") + " (" + t("credit_card") + ")";
      if (pType == "Payout") {
        label = t("payout_form");
      }
      if (label == "") label = t(pType);

      if (pStatus && pStatus == "ERROR") {
        label += "";
      } else if (pStatus) label += " " + pStatus;
    }

    return label;
  };
  let walletData = [];
  const fillData = () => {
    if (typeof props.wallets === "undefined") return;
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    for (let i = 0; i < props.wallets.length; i++) {
      let addClasses = "";
      let elements = [];
      let toggle = false;
      let wallet = props.wallets[i];
      let hasOrder = false;
      let hasAccInvoice = false;
      let hasAbo = false;
      hasOrder = typeof wallet.order !== "undefined" && wallet.order !== null;
      hasAccInvoice =
        typeof wallet.accumulated_invoice_id !== "undefined" &&
        wallet.accumulated_invoice_id !== null
          ? true
          : false;
      hasAbo =
        typeof wallet.abonnement !== "undefined" && wallet.abonnement !== null ? true : false;
      let item = hasOrder
        ? "o" + wallet.order_id
        : hasAccInvoice
          ? "a" + wallet.accumulated_invoice_id
          : "i" + i;
      if (
        typeof searchParams.get("item") !== "undefined" &&
        searchParams.get("item") !== null &&
        item === searchParams.get("item")
      ) {
        toggle = true;
      }
      elements = [
        {
          type: "text",
          value: "client",
          title: "",
          data: [
            {
              value: "client",
              text: hasOrder
                ? props.clients[wallet.order.client_id]
                : hasAccInvoice
                  ? props.clients[wallet.accumulated_invoice.client_id]
                  : hasAbo
                    ? props.clients[wallet.client_id]
                    : "",
              extraClasses: "text-small",
              title: t("date", null, "capital"),
            },
          ],
          mediumWidth: 2,
          smallWidth: 4,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: hasAccInvoice ? "acc_invoice" : "order_nbr",
          title: "",
          extraTopClasses: "item-inline",
          data: [
            {
              value: hasAccInvoice
                ? "acc_invoice_" + wallet.accumulated_invoice_id
                : hasOrder
                  ? "order_nbr"
                  : hasAbo
                    ? "abo_" + wallet.abonnement.id
                    : "",
              text: hasAbo
                ? t("Abonnement") + " " + wallet.abonnement.description
                : hasAccInvoice
                  ? t("invoice") + " " + wallet.accumulated_invoice_id
                  : hasOrder
                    ? wallet.order.order_nbr + " " + t(wallet.order.status) + " "
                    : "",
              extraClasses: "text-small",
              title: hasAbo
                ? t("Abonnement")
                : hasAccInvoice
                  ? t("invoice", null, "capital")
                  : hasOrder
                    ? t("order_nbr", null, "capital")
                    : "-",
              ref: hasAccInvoice
                ? "#"
                : hasOrder
                  ? "/orders/" + wallet.order_id + "/edit"
                  : hasAbo
                    ? "/abonnements/" + wallet.abonnement.id
                    : "#",
            },
            {
              value: "order_payment",
              text: hasOrder
                ? " " +
                  FormatHelper.currencyFormat(wallet.order.paid) +
                  " " +
                  Biscuit.get("client.currency") +
                  " "
                : "",
              extraClasses: "text-small",
              title: t("payments", null, "capital"),
            },
            {
              value: hasOrder
                ? typeof wallet.order.user_id !== "undefined" || wallet.order.user_id !== null
                  ? "user_" + wallet.order.user_id
                  : hasAbo
                    ? "user_" + wallet.abonnements_user.user_id
                    : "user"
                : "user",
              text: " ",
              icon: hasOrder || hasAbo ? "fi fi-torso" : "fi",
              extraClasses: "text-small",
              title: t("show_user", null, "capital"),
              ref: "#",
            },
            {
              value: "order_payment_link",
              text: "",
              icon: hasOrder ? "fi fi-euro" : "fi",
              extraClasses: "text-medium",
              title: t("show_payment", null, "capital"),
              ref: hasOrder ? "/orders/" + wallet.order.id + "/addpaymentfromwallet" : "#",
            },
            {
              value: "order_payment",
              text: "",
              extraClasses: "text-small",
              title: t("price", null, "capital"),
            },
          ],
          mediumWidth: 3,
          smallWidth: 3,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "payment_date",
          title: "",
          data: [
            {
              value: "paid",
              text: FormatHelper.currencyFormat(wallet.paid) + " " + Biscuit.get("client.currency"),
              extraClasses: "text-small",
              title: t("paid", null, "capital"),
            },
            {
              value: "paidPaymentDate",
              text: moment(wallet.paidPaymentDate).format("dd, DD.MM.YYYY, HH:mm"),
              extraClasses: "text-small",
              title: t("date", null, "capital"),
            },
            {
              value: "paidTransactionNbr",
              text: wallet.paidTransactionNbr,
              extraClasses: "text-small",
              title: t("reference", null, "capital"),
            },
          ],
          mediumWidth: 2,
          smallWidth: 4,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "fee_date",
          title: "",
          data: [
            {
              value: "fee",
              text:
                typeof wallet.fee !== "undefined"
                  ? FormatHelper.currencyFormat(wallet.fee) + " " + Biscuit.get("client.currency")
                  : "",
              extraClasses: "text-small",
              title: t("fee", null, "capital"),
            },
            {
              value: "feePaymentDate",
              text:
                typeof wallet.feePaymentDate !== "undefined"
                  ? moment(wallet.feePaymentDate).format("dd, DD.MM.YYYY, HH:mm")
                  : "",
              extraClasses: "text-small",
              title: t("date", null, "capital"),
            },
          ],
          mediumWidth: 2,
          smallWidth: 4,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "refund_date",
          title: "",
          data: [
            {
              value: "refund",
              text:
                typeof wallet.refund !== "undefined"
                  ? FormatHelper.currencyFormat(wallet.refund) +
                    " " +
                    Biscuit.get("client.currency")
                  : "",
              extraClasses: "text-small",
              title: t("refund", null, "capital"),
            },
            {
              value: "refundPaymentDate",
              text:
                typeof wallet.refundPaymentDate !== "undefined"
                  ? moment(wallet.refundPaymentDate).format("dd, DD.MM.YYYY, HH:mm")
                  : "",
              extraClasses: "text-small",
              title: t("date", null, "capital"),
            },
            {
              value: "paidTransactionNbr",
              text: wallet?.refundTransactionNbr || "",
              extraClasses: "text-small",
              title: t("refundTransactionNbr", null, "capital"),
            },
          ],
          mediumWidth: 2,
          smallWidth: 4,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "payment_type",
          title: "",
          data: [
            {
              value: "payment_type",
              text: t(wallet.payment_type),
              extraClasses: "text-small",
              title: t("payment type", null, "capital"),
            },
          ],
          mediumWidth: 1,
          smallWidth: 2,
          handler: onItemClickedHandler,
        },
        {
          type: "TransactionAddition",
          value: "wallet_transactions",
          title: "",
          data: [
            {
              value: "wallet_transactions",
              text: "",
              title: "",
              transactions: wallet.wallet_transactions,
              id: hasOrder ? wallet.order_id : hasAccInvoice ? wallet.accumulated_invoice_id : null,
              app_user_role: Biscuit.get("user.role"),
              dispatch: props.dispatch,
            },
          ],
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
      ];

      if (toggle) {
        addClasses = " toggled";
      }
      if (elements !== []) {
        walletData[i] = {
          elements: elements,
          addClasses: addClasses,
        };
      }
    }
  };

  const onItemClickedHandler = (value) => {
    console.log("clicked on: ", value);
    if (value.startsWith("acc_invoice_")) {
      // open accumulated invoice
      const id = value.split("acc_invoice_")[1];

      props.dispatch(
        salesBillingsActions.getSalesBillings({
          token: Biscuit.get("token"),
          suffix: "",
          filter: {
            page: 1,
            accumulated_invoice_id: id,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
    if (value.startsWith("user_")) {
      // fetch user info
      const id = value.split("user_")[1];
      const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

      props.dispatch(
        userActions.getUser({
          token: Biscuit.get("token"),
          id: id,
        }),
      );

      setPopup({
        ...popup,
        left: el_rect.left + "px",
        top: el_rect.top + "px",
        text: t("user", null, "capital") + ":",
      });
    }
    if (value.startsWith("payment_info_")) {
      const idx = value.split("payment_info_")[1];
      const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

      setPopup({
        ...popup,
        left: el_rect.left + "px",
        top: el_rect.top + "px",
        open: true,
        text: t("payment_error_info") + ": " + props.wallets[idx].message,
        link: "",
        linkText: "",
      });
    }
  };

  const popupCloseHandler = () => {
    setPopup({
      ...popup,
      open: false,
    });
  };

  fillData();
  return (
    <div
      className="inb-c-listing off-canvas-content"
      id="inb-c-main-transactions"
      style={{ minHeight: "1150px" }}
    >
      {typeof props.wallets !== "undefined" &&
        props.wallets.map((wallet, index) => {
          return (
            <AdminTransactionListItem
              key={"wti-" + index}
              listStyle="tight"
              id={
                "wallet-transactions-item-" +
                (wallet.order_id !== null
                  ? "o" + wallet.order_id
                  : wallet.accumulated_invoice_id !== null
                    ? "a" + wallet.accumulated_invoice_id
                    : "i" + index)
              }
              wallet={wallet}
              length={wallet.wallet_transactions.length}
              overwriteClasses={"inb-c-item row" + walletData[index].addClasses}
              menu={[]}
              elements={walletData[index].elements}
            />
          );
        })}
      {popup.open === true && (
        <Popup
          left={popup.left}
          top={popup.top}
          linkText={popup.linkText}
          text={popup.text}
          link={popup.link}
          onCloseHandler={popupCloseHandler}
        />
      )}
    </div>
  );
};
export default AdminTransactionsList;
